// extracted by mini-css-extract-plugin
export default {"root":"ProjectList_root__eN8kf","item":"ProjectList_item__HWwNC","w100":"ProjectList_w100__LoU5D","closed":"ProjectList_closed__hdgei"};